import NavElement from "./navElement";
import { Link, Outlet } from "react-router-dom";
import constants from "../../constants";
import UserSection from './userSection';
import { useUser } from "../../context/UserContext";
import { useEffect, useMemo, useState } from 'react';
import api from '../../api/api';

const Nav = ({items}) => {
    const { user } = useUser();
    const [ownerPropertyCount, setOwnerPropertyCount] = useState(0);
    const [hasCleanerProfile, setHasCleanerProfile] = useState(false);
    /*const validate = async () => {
        try {
            const eso = await api.get('/user/validateToken');
            console.log('eso', eso);
            
        } catch (e) {
            //setAuth(false);
        }
    };

    useEffect(() => {
        validate();
    }, []);*/

    const sideItems = ['About', 'Contact', 'Blog', 'Listings'];
    const primaryItems = items.filter((i) => !sideItems.includes(i));
    const isGuestUser = user?.role === 'guest';
    const isCleanerAccount = user?.role === 'cleaner';
    const isHostUser = !!user && !isGuestUser && !isCleanerAccount;
    const isCleanerUser = Boolean(user) && (isCleanerAccount || hasCleanerProfile);
    const normalizedUserId = Number(user?.id);
    const isOwnerUser = ownerPropertyCount > 0;

    useEffect(() => {
        let cancelled = false;

        const loadOwnerStatus = async () => {
            if (!isHostUser || !Number.isInteger(normalizedUserId) || normalizedUserId <= 0) {
                setOwnerPropertyCount(0);
                return;
            }

            try {
                const response = await api.get('/property');
                const ownedCount = (Array.isArray(response?.data) ? response.data : [])
                    .filter((property) => Number(property.ownerUserId) === normalizedUserId)
                    .length;
                if (!cancelled) setOwnerPropertyCount(ownedCount);
            } catch (error) {
                if (!cancelled) setOwnerPropertyCount(0);
            }
        };

        loadOwnerStatus();

        return () => {
            cancelled = true;
        };
    }, [isHostUser, normalizedUserId]);

    useEffect(() => {
        let cancelled = false;
        if (!user?.token) {
            setHasCleanerProfile(false);
            return undefined;
        }
        api.get('/cleaner-workforce/profile/me')
            .then((response) => { if (!cancelled) setHasCleanerProfile(Boolean(response?.data?.isCleaner)); })
            .catch(() => { if (!cancelled) setHasCleanerProfile(false); });
        return () => { cancelled = true; };
    }, [user?.id, user?.token]);

    const filteredPrimaryItems = useMemo(() => {
        return primaryItems.filter((item) => {
            if (item === 'Operations') return isOwnerUser;
            if (item === 'Tasks') return isHostUser;
            if (item === 'CleanerDashboard') return isCleanerUser;
            return true;
        });
    }, [primaryItems, isOwnerUser, isHostUser, isCleanerUser]);

    const guestPrimaryItems = primaryItems.filter((i) => i === 'Chat' || i === 'Trips' || (i === 'CleanerDashboard' && isCleanerUser));
    const hostPrimaryItems = filteredPrimaryItems.filter((i) => i !== 'Trips');
    const visiblePrimaryItems = user
        ? (isCleanerAccount ? ['CleanerDashboard'] : isGuestUser ? ['Listings', ...guestPrimaryItems] : hostPrimaryItems)
        : ['Listings'];
    const secondaryItems = items
        .filter((i) => sideItems.includes(i))
        .filter((i) => i !== 'Listings')
        .filter((i) => !(isHostUser && ['About', 'Contact', 'Blog'].includes(i)));
    const isAdmin = user?.email === 'davebradham@gmail.com';

    const primaryContent = visiblePrimaryItems.map((i) => {
        const path = i === 'P&L' ? 'Pnl' : i;
        const title = i === 'CleanerDashboard' ? 'My Cleanings' : i;
        return <NavElement key={i} title={title} path={path} />;
    });

    const secondaryContent = secondaryItems.map((i) => {
        const path = i === 'P&L' ? 'Pnl' : i;
        return <NavElement key={i} title={i} path={path} subtle />;
    });
        
    return (
        <div>
            <nav className="nav nav-wide">
                <div className="nav-shell">
                    <Link to="/" className="nav-brand pretty-link">
                        <span className="nav-brand-kicker">Property Intelligence</span>
                        <span className="nav-brand-name">{constants.name}</span>
                    </Link>
                    <div className="nav-links-secondary nav-links-secondary-wide">
                        {secondaryContent}
                    </div>
                    <div className="nav-links">
                        {primaryContent}
                        {isAdmin && !isGuestUser && <NavElement key="SignupRequests" title="Users" path="SignupRequests" />}
                    </div>
                    <div className="nav-user-area">
                        <UserSection />
                    </div>
                </div>
            </nav>


            <nav className="nav nav-small">
                <div className="nav-shell nav-shell-mobile">
                    <Link to="/" className="nav-brand pretty-link">
                        <span className="nav-brand-kicker">Property Intelligence</span>
                        <span className="nav-brand-name">{constants.name}</span>
                    </Link>
                    <div className="nav-links-secondary nav-links-secondary-mobile">
                        {secondaryContent}
                    </div>
                    <div className="nav-links nav-links-mobile">
                        {primaryContent}
                        {isAdmin && !isGuestUser && <NavElement key="SignupRequests" title="Users" path="SignupRequests" />}
                    </div>
                    <div className="nav-user-area nav-user-area-mobile">
                        <UserSection />
                    </div>
                </div>
            </nav>
            <Outlet />
        </div>
    );
};

export default Nav;